import { apiClient } from './apiClient';
import { authStorageService } from './authStorageService';
import { API_ENDPOINTS } from '../config/api';

const persistSession = response => {
  const accessToken = response?.data?.data?.access_token;
  const user = response?.data?.data?.user;

  if (!accessToken || !user) {
    return Promise.reject(new Error('Invalid login response from server.'));
  }
  return authStorageService.storeAuthData({ accessToken, user }).then(() => response);
};

export const authService = {
  login: credentials => {
    return apiClient.post(API_ENDPOINTS.auth.login, credentials, { suppressToast: true }).then(persistSession);
  },

  logout: () => {
    return authStorageService.getAuthData().then(authData => {
      authStorageService.clearAuthData();

      if (authData && authData.accessToken) {
        return apiClient
          .post(
            API_ENDPOINTS.auth.logout,
            {},
            {
              headers: {
                Authorization: `Bearer ${authData.accessToken}`
              }
            }
          )
          .catch(() => {}); // Ignore logout API errors
      }
    });
  },

  requestPasswordReset: ({ email }) => {
    return apiClient.post(API_ENDPOINTS.auth.forgotPassword, { email });
  },

  verifyPasswordResetToken: token => {
    return apiClient.post(API_ENDPOINTS.auth.verifyPasswordResetToken, { token });
  },

  resetPassword: (token, newPassword) => {
    return apiClient.post(API_ENDPOINTS.auth.resetPassword, {
      token,
      password: newPassword,
      confirm_password: newPassword
    });
  },

  setPassword: (newPassword, confirmPassword) => {
    return authStorageService.getAuthData().then(authData => {
      const token = authData ? authData.accessToken : null;
      if (!token) {
        throw new Error('Authentication token not found.');
      }
      return apiClient.post(API_ENDPOINTS.auth.setPassword, {
        new_password: newPassword,
        confirm_password: confirmPassword
      });
    });
  }
};
